import { render } from "./Jewelry.vue?vue&type=template&id=dbb12512"
import script from "./Jewelry.vue?vue&type=script&lang=js"
export * from "./Jewelry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__